import { render } from "./FormContact.vue?vue&type=template&id=d0584b38&scoped=true"
import script from "./FormContact.vue?vue&type=script&lang=js"
export * from "./FormContact.vue?vue&type=script&lang=js"

import "./FormContact.vue?vue&type=style&index=0&id=d0584b38&lang=scss&scoped=true"

import exportComponent from "/home/forge/binalogue.stage-preview.com/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d0584b38"]])

export default __exports__